import { RichTranslator, useTranslator } from '@bluebeam/react-i18n';
import ConnectedAccount from 'components/ConnectedAccount';
import { useIntegrationsCheck } from 'hooks/useIntegrationsCheck';
import React from 'react';
import { Link } from 'react-router-dom';
import { ConnectedAccountList } from 'records/ConnectedAccount';

type Props = {
  accounts: ConnectedAccountList;
  onClick: (providerType: string, connectedAccountId: string) => void;
};

const ImportConnectedAccounts: React.FC<Props> = ({
  accounts,
  onClick,
}: Props) => {
  const { translate } = useTranslator(['drawingsIntegrationsText']);
  if (!accounts.size) {
    const { areAccountIntegrationsEnabled } = useIntegrationsCheck();

    return (
      <div className="column justify-center align-self-center h100 w100">
        <div className="bold mb2 font-size-5 row justify-center pl7 pr7">
          {areAccountIntegrationsEnabled
            ? translate(
                'drawingsIntegrationsText:modal.accountIntegrations.empty.noAccounts'
              )
            : translate(
                'drawingsIntegrationsText:modal.empty.noActiveAccounts'
              )}
        </div>
        <div className="mb5 light font-size-5 justify-center pl9 pr9">
          {areAccountIntegrationsEnabled ? (
            <RichTranslator
              components={[<Link to="/connected-accounts" target="_blank" />]}
              translationKey="drawingsIntegrationsText:modal.accountIntegrations.empty.description"
            />
          ) : (
            translate('drawingsIntegrationsText:modal.empty.description')
          )}
        </div>
      </div>
    );
  }
  return (
    <>
      {accounts.map((connectedAccount, index) => {
        return (
          <ConnectedAccount
            key={connectedAccount.id}
            account={connectedAccount}
            index={index}
            label={connectedAccount.label}
            onClick={() =>
              onClick(connectedAccount.providerType, connectedAccount.id)
            }
          />
        );
      })}
    </>
  );
};

export default ImportConnectedAccounts;
